module.exports = __webpack_public_path__ + "static/Logo.a1d14c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo.png
// module id = 932
// module chunks = 237044687278113